// Tracking API base URL per environment (selected by REACT_APP_ENV).
const envUrls = {
  dev: {
    trackingURL: "https://devapis.delcaper.com/tracking/v2",
  },
  qa: {
    trackingURL: "https://qaapis.hubops.innofulfill.com/tracking/v2",
  },
  uat: {
    trackingURL: undefined,
  },
  prod: {
    trackingURL: "https://apis-hubops.innofulfill.com/tracking/v2",
  },
};

export default envUrls;
